import Select from '../select/Select';

export default Select;
